import { ButtonCheckbox } from '@/components/common/Button'
import { InputTypeahead } from '@/components/common/Input'
import { Icon } from '@/components/icons/Icon'
import { usePage } from '@/components/providers/PageProvider'
import { type TypeaheadOptionType } from '@/defs/input'
import { useLinkInternal } from '@/hooks/useLinkInternal'

import styles from './FeaturedRecPartnersChooser.module.scss'

export const FeaturedRecPartnersChooser = () => {
  const { redirectUrl } = useLinkInternal()
  const { page } = usePage()

  const partnerOptions = page?.featured?.optionsPartners
  const partnerOptionButtons = partnerOptions?.slice(0, 4)

  const options = partnerOptions?.map<TypeaheadOptionType<string>>(({ label, link }) => ({
    label,
    value: link || '',
  }))

  return (
    <div className={styles.container}>
      <span className={styles.icon}>
        <Icon name='hatCowboy' />
      </span>
      <p className={styles.title}>Choose a Partner</p>
      <ul className={styles.list}>
        {partnerOptionButtons?.map((b, i) => (
          <li key={i}>
            <ButtonCheckbox as='LinkRoute' checkNone count={b.count} href={b.link || '/'}>
              {b.label}
            </ButtonCheckbox>
          </li>
        ))}
        {options && options.length > 4 && (
          <li>
            <InputTypeahead
              aria-label='Seach for more partners'
              icon='search'
              onSelect={(value) => redirectUrl(value)}
              options={options}
              placeholder='More Partners...'
            />
          </li>
        )}
      </ul>
    </div>
  )
}
